import React from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Descriptions, Divider, Drawer, Space, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import { useNavigate } from "react-router-dom";
import { DashboardRoutes } from "@/router/constant";
import { dateFormats, toJalali } from "@payping/utils/dateUtils";
import { buildUrl } from "@payping/utilities-shared/url";
import { URLS } from "@payping/utilities-shared/consts";

const MobileProfileDetails: React.FC = () => {
  const { t } = useAppTranslation();
  const navigate = useNavigate();
  const personalInfo = useAppSelector((state) => state.user.personalInfo);
  const username = useAppSelector((state) => state.user.personalInfo?.username);
  const url = buildUrl(URLS.PPNG_URL, username).toString();

  return (
    <Drawer
      title={t("profile.userProfile")}
      open
      height={"100%"}
      placement={"bottom"}
      closeIcon={false}
      extra={
        <Button
          type={"text"}
          icon={<Close width={14} height={14} />}
          onClick={() => {
            navigate(DashboardRoutes.profile.mRoot.url);
          }}
        />
      }
    >
      <Descriptions column={1} layout={"vertical"} size={"middle"} className={"tw:w-full tw:mt-12!"}>
        <Descriptions.Item label={t("firstName")}>
          <Space orientation={"vertical"} className={"tw:w-full"} size={"small"}>
            <Typography.Text>{personalInfo?.firstName || t("notRegistered")}</Typography.Text>
            <Divider className={"background--gray100 tw:m-0!"} />
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={t("lastName")}>
          <Space orientation={"vertical"} className={"tw:w-full"} size={"small"}>
            <Typography.Text>{personalInfo?.lastName || t("notRegistered")}</Typography.Text>
            <Divider className={"background--gray100 tw:m-0!"} />
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={t("nationalCode")}>
          <Space orientation={"vertical"} className={"tw:w-full"} size={"small"}>
            <Typography.Text>{personalInfo?.nationalCode || t("notRegistered")}</Typography.Text>
            <Divider className={"background--gray100 tw:m-0!"} />
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={t("birthDate")}>
          <Space orientation={"vertical"} className={"tw:w-full"} size={"small"}>
            <Typography.Text>
              {toJalali({
                date: personalInfo?.birthDate,
                dateFormat: dateFormats.ui.utcDateTime,
                toFormat: dateFormats.ui.utcDate,
              }).string || t("notRegistered")}
            </Typography.Text>
            <Divider className={"background--gray100 tw:m-0!"} />
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={t("common.username")}>
          <Space orientation={"vertical"} className={"tw:w-full"} size={"small"}>
            <Typography.Text>{personalInfo?.username || t("notRegistered")}</Typography.Text>
            <Divider className={"background--gray100 tw:m-0!"} />
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={t("mobileNumber")}>
          <Space orientation={"vertical"} className={"tw:w-full"} size={"small"}>
            <Typography.Text>{personalInfo?.phoneNumber || t("notRegistered")}</Typography.Text>
            <Divider className={"background--gray100 tw:m-0!"} />
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={t("email")}>
          <Space orientation={"vertical"} className={"tw:w-full"} size={"small"}>
            <Typography.Text>{personalInfo?.email || t("notRegistered")}</Typography.Text>
            <Divider className={"background--gray100 tw:m-0!"} />
          </Space>
        </Descriptions.Item>
        <Descriptions.Item label={t("common.linkPersonalPage")}>
          <Space orientation={"vertical"} className={"tw:w-full"} size={"small"}>
            <Typography.Text>{url || t("notRegistered")}</Typography.Text>
            <Divider className={"background--gray100 tw:m-0!"} />
          </Space>
        </Descriptions.Item>
      </Descriptions>
    </Drawer>
  );
};

export default MobileProfileDetails;
